import { Suspense } from 'react';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';

import ErrorBoundary from '@/components/ErrorBoundary';
import { FinancialYearInitializer } from '@/components/FinancialYearInitializer';
import { FirebaseInitializer } from '@/components/FirebaseInitializer';
import { FirebaseNotificationHandler } from '@/components/FirebaseNotificationHandler';
import { SessionInitializer } from '@/components/SessionInitializer';
import { Toaster } from '@/components/ui/toast';
import { router } from '@/router';
import { store } from '@/store';
import { useAppSelector } from '@/store/hooks';
import '@/styles/globals.css';
import { useGlobalErrorToast } from '@/hooks/useGlobalErrorToast';

function AppContent() {
  // Get user data for notifications
  const { session } = useAppSelector((state) => state.user);
  const userData = session.user;

  // Listen for global API error toast events
  useGlobalErrorToast();

  return (
    <>
      <RouterProvider router={router} />
      {/* Firebase Notification Handler - Silent background component */}
      {userData?.branch_code && (
        <FirebaseNotificationHandler
          uid={userData.branch_code}
          enabled={true}
          autoRequestPermission={false}
        />
      )}
    </>
  );
}

function App() {
  return (
    <Provider store={store}>
      <FirebaseInitializer
        enableFirebase={true}
        enableServiceWorker={true}
        onInitialized={(success, error) => {
          if (success) {
            console.log('🎉 Firebase notifications ready');
          } else {
            console.warn('⚠️ Firebase notifications unavailable:', error);
          }
        }}
      >
        <SessionInitializer>
          <FinancialYearInitializer>
            <ErrorBoundary fallback={<div>Something went wrong!</div>}>
              <AppContent />
              <Toaster />
            </ErrorBoundary>
          </FinancialYearInitializer>
        </SessionInitializer>
      </FirebaseInitializer>
    </Provider>
  );
}

export default App;
